<template lang="pug">
el-dialog.newDialog(center='', :title='title', :visible='showvisible', width='1100px',:show-close="false",:close-on-click-modal="false")
    .editFormDialog 
        table.form(cellpadding='0', cellspacing='0', border='0')
            tbody
                tr
                    th(width='10%') 巡查任务名称
                    td(width='40%')
                        | {{fatherdata.name}}
                    th(width='10%') 巡查任务内容
                    td(width='40%')
                        | {{fatherdata.content}}
                tr
                    th(width='10%') 所属机构
                    td(width='40%')
                        | {{fatherdata.orgName}}
                    th(width='10%') 所属人员
                    td(width='40%')
                        | {{fatherdata.userName}}
                tr
                    th 任务名称
                    td
                        | {{fatherdata.way ? fatherdata.way.name :''}}
                    th 任务内容
                    td
                        | {{fatherdata.way ? fatherdata.way.content :''}}
                tr
                    th 开始时间
                    td
                        | {{fatherdata.starttime}}
                    th 结束时间
                    td
                        | {{fatherdata.endtime}}
                tr
                    th 是否完成
                    td
                        | {{fatherdata.status == 0?"否":"是"}}
                    th 完成时间
                    td
                        | {{fatherdata.scantime}}
                tr
                    th 扫码人员
                    td
                        | {{fatherdata.scanuserCn}}
                    th 扫码地址
                    td
                        | {{fatherdata.place}}
                tr
                    th 时间是否异常
                    td
                        | {{fatherdata.isnormalTime == null ? "" :(fatherdata.isnormalTime == 0 ? "否" : '是')}}
                    th 位置是否异常
                    td
                        | {{fatherdata.isnormal == null ? "" :(fatherdata.isnormal == 0 ? "否" : '是')}}
                tr
                    th 分配地图:
                    td(colspan='3', align='center')  
                        .mapBox
                            showAddressMap(v-bind="showMap")


   

        .dialog-footer(slot='footer')
            el-button(v-if='!readonly' type='primary', size='small',  @click='saveNext') 保存
            el-button(type='info', size='small', @click='dialogClose') 取消
 
</template>

<script>
import { livelihoodsLiveStreamApi, livelihoodsTypesApi } from "@/api/http";

import showAddressMap from "./showAddressMap.vue";

export default {
  name: "editFormDialog",
  props: ["readonly", "show", "fatherid", "fatherdata", "pagetype"],
  components: { showAddressMap },
  data() {
    return {
      showMap: {
        mapid: "showmap_1",
        mapwidth: "600",
        mapheight: "250",
        longitude: "",
        latitude: "",
        address: ""
      },
      cascaderProps: {
        value: "id",
        label: "typesName",
        children: "childTypes"
      },
      cascaderKey: 0,
      cascaderData: [],
      fileLists: [],
      ruleArr: {
        liveTitle: [
          { required: true, message: "请输入直播主题", trigger: "blur" }
        ],
        // liveOwner: [
        //   { required: true, message: "请输入直播帐户", trigger: "blur" }
        // ],
        timeArr: [
          { required: true, message: "请选择直播时间", trigger: "change" }
        ],
        liveTypesIdStr: [
          { required: true, message: "请选择直播类型", trigger: "change" }
        ]
      },
      links:
        "rtmp://live.qmkjzh.com/czzhsq/0000_lhd?auth_key=1586875485-0-0-f565498e1713785c53345a7190565147",
      messageContentTextObj: {
        1: "服务指南内容:",
        2: "信息分类:"
      },
      values: "1",
      baseForm: { timeArr: [], liveTypesIdStr: [] }
    };
  },
  computed: {
    showvisible() {
      if (this.show == "add") {
        this.getTreedata();

        if (this.fatherid) {
          let newbaseForm = this.fatherdata;
          newbaseForm.timeArr = [
            newbaseForm.liveStartTime,
            newbaseForm.liveEndTime
          ];

          if (typeof newbaseForm.liveTypesIdStr == "string") {
            const liveTypesIdStr = newbaseForm.liveTypesIdStr.split(",");
            newbaseForm.liveTypesIdStr = liveTypesIdStr.map(it => Number(it));
          } else {
            newbaseForm.liveTypesIdStr = [];
          }

          this.baseForm = newbaseForm;
        }
        return true;
      }
      return false;
    },
    title() {
      if (this.fatherid) {
        if (this.readonly) return "查看";
        return "编辑";
      }

      return "新增";
    },
    readOnly2() {
      //   console.log(this.readonly);
      if (this.readonly) {
        return true;
      }
      return false;
    }
  },
  methods: {
    dialogClose(val) {
      let text = "close";
      if (val) text = val;
      this.$emit("func", {
        dialog: text,
        data: ""
      });

      this.resetData();
    },
    resetData() {
      this.baseForm = {};
      this.cascaderKey = 0;
      //   this.$refs.baseForm.resetFields();
    },
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      if (this.searchlist.stime) {
        this.searchlist.activityStartTime = this.searchlist.stime[0];
        this.searchlist.activityEndTime = this.searchlist.stime[1];
      } else {
        this.searchlist.activityStartTime = "";
        this.searchlist.activityEndTime = "";
      }

      this.getPageDatas();
    },

    //根据输入地址转换经纬度并标记
    saveNext() {
      this.$refs.baseForm.validate(valid => {
        if (valid) {
          this.saveNext2();
        } else {
          //   console.log("error submit!!");
          return false;
        }
      });
    },
    //弹框保存
    async saveNext2() {
      let apidata = JSON.parse(JSON.stringify(this.baseForm));
      apidata.type = this.pagetype;
      apidata.liveStartTime = apidata.timeArr[0];
      apidata.liveEndTime = apidata.timeArr[1];
      apidata.liveTypesId =
        apidata.liveTypesIdStr[apidata.liveTypesIdStr.length - 1];

      apidata.liveTypesIdStr = apidata.liveTypesIdStr.join(",");

      apidata.timeArr = JSON.stringify(apidata.timeArr);

      let apiText = "添加";
      let apiRes = "";

      if (apidata.id) {
        apiText = "编辑";
        apiRes = await livelihoodsLiveStreamApi.updata(apidata);
      } else {
        apiText = "新增";
        apiRes = await livelihoodsLiveStreamApi.insert(apidata);
      }

      if (apiRes && apiRes.code == 200) {
        this.$message({
          message: apiText + "成功",
          type: "success"
        });
        this.dialogClose("success");
        return;
      }

      this.$message({
        message: apiText + "失败",
        type: "error"
      });
    },
    //上传
    handleExceed(files, fileList) {
      var selected = files.length;
      var totalselected = selected + fileList.length;
      this.$message.warning(
        "当前限制选择10个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      );
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccess(response, file, fileList) {
      //   console.log(response);

      if (response.code == 200) {
        this.fileLists.push({
          name: response.content.name,
          url: response.content.path
        });
      }
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;
    },
    //附件预览
    handlePreview(file) {
      console.log(file);

      window.open(file.url);
    },
    handleCascaderChange(value) {
      //   console.log(this.$refs.searchArea.getCheckedNodes()[0].data);
    },
    async getTreedata() {
      let apidata = {
        type: this.pagetypes
      };
      const apiRes = await livelihoodsTypesApi.getTypeTree(apidata);
      if (apiRes && apiRes.code == 200) {
        this.cascaderData = apiRes.content || [];

        this.setDisable(1, this.cascaderData, 0);
        this.cascaderKey += 1;
      }
    },
    // 超过3级,不能选中,子级分类最多4级
    /**
     * count: 当前层级
     * data: 当前层级的数据
     * maxNum: 最多不能超过几级
     */
    setDisable(count, data, maxNum) {
      if (count > maxNum) {
        //最多几级就写几
        data.forEach(v => {
          v.disabled = true; // 超过设定的最大级数,给这一集的数据添加disabled属性
        });
      } else {
        data.forEach(v => {
          v.count = count; // 设置最外层数据的初始count

          if (v.childs && v.childs.length) {
            v.count++;
            this.setDisable(v.count, v.childs, maxNum); // 子级循环时把这一层数据的count传入
          }
        });
      }
    }
  },
  mounted() {},
  created() {}
};
</script>
<style lang="less" >
.editFormDialog {
  .dialog-footer {
    margin-top: 20px;
    text-align: center;
  }
  table.form {
    width: 99.9%;
    border-collapse: collapse;
    border: none;
    th {
      line-height: 2.5;
      text-align: right;
      background: #f3f9fd;
    }
    td {
      line-height: 2.5;
      border: 1px solid #ececec;
      padding: 1px 5px;
    }
    .mapBox {
      width: 100%;
      height: 350px;
    }
  }
}
</style>